import { Props } from './UpdateReferral'

import { Theme } from '@mui/material/styles'

export const getStyles = (props: Props, theme: Theme) => ({
  billToContainer: {
    marginRight: theme.spacing(0),
    minWidth: '360px',
  },

  bottomRowContainer: {
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
  },

  container: {
    flex: '0 0 100%',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: props.padding ? `${props.padding}px` : theme.spacing(1),
  },

  discountInfoContainer: {
    alignSelf: 'start',
    flexGrow: 0,
    maxWidth: '360px',
  },

  discountContainer: {
    alignSelf: 'end',
    flexGrow: 1,
    maxWidth: '360px',
  },

  label: {
    fontFamily: 'Source Sans Pro',
    color: theme.palette.text.primary,
    fontSize: '14px',
    marginBottom: theme.spacing(1.5),
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
    color: theme.palette.text.primary,
    fontSize: '16px',
    marginTop: theme.spacing(0.2),
  },

  error: {
    color: theme.palette.error.main,
  },

  button: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(8),
    fontFamily: 'Source Sans Pro Semibold',
    fontWeight: '400',
    fontSize: '14px',
  },
})
